(function(){
  if(window.__nxSF) return; window.__nxSF=1;
  var css=''
   +'.nx-sf-btn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;box-sizing:border-box;margin:10px 0;padding:12px 14px;border:1px solid #111;border-radius:10px;background:#fff;color:#111;font:600 14px/1.2 inherit;cursor:pointer;letter-spacing:.02em}'
   +'.nx-sf-btn:hover{background:#111;color:#fff}'
   +'.nx-sf-ov{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.55);display:none;align-items:flex-end;justify-content:center}'
   +'.nx-sf-ov.on{display:flex}'
   +'@media(min-width:640px){.nx-sf-ov{align-items:center}}'
   +'.nx-sf-card{background:#fff;width:100%;max-width:460px;max-height:92vh;overflow:auto;border-radius:16px 16px 0 0;padding:20px;box-sizing:border-box;font:14px/1.45 inherit;color:#111;-webkit-overflow-scrolling:touch}'
   +'@media(min-width:640px){.nx-sf-card{border-radius:16px}}'
   +'.nx-sf-head{display:flex;align-items:flex-start;justify-content:space-between;gap:10px}'
   +'.nx-sf-title{font-size:18px;font-weight:700;margin:0}'
   +'.nx-sf-x{background:none;border:0;font-size:26px;line-height:1;cursor:pointer;color:#111;padding:0 2px}'
   +'.nx-sf-sub{color:#666;margin:2px 0 16px}'
   +'.nx-sf-field{margin:0 0 14px}'
   +'.nx-sf-field label{display:block;font-weight:600;margin-bottom:6px}'
   +'.nx-sf-field input,.nx-sf-field select{width:100%;box-sizing:border-box;padding:11px 12px;border:1px solid #ccc;border-radius:9px;font:15px inherit;background:#fff;color:#111}'
   +'.nx-sf-seg{display:flex;gap:8px;flex-wrap:wrap}'
   +'.nx-sf-seg button{flex:1;min-width:78px;padding:10px;border:1px solid #ccc;border-radius:9px;background:#fff;cursor:pointer;font:600 13px inherit;color:#111}'
   +'.nx-sf-seg button.sel{border-color:#111;background:#111;color:#fff}'
   +'.nx-sf-go{width:100%;padding:13px;border:0;border-radius:10px;background:#111;color:#fff;font:700 15px inherit;cursor:pointer;margin-top:4px}'
   +'.nx-sf-howtoggle{font-size:12px;color:#777;margin:6px 0 0;cursor:pointer;text-decoration:underline;display:inline-block}'
   +'.nx-sf-howto{font-size:12.5px;color:#555;background:#f6f6f6;border-radius:9px;padding:10px 12px;margin:8px 0 0;display:none}'
   +'.nx-sf-howto.on{display:block}'
   +'.nx-sf-res{text-align:center;padding:4px 0}'
   +'.nx-sf-res .lab{color:#888;text-transform:uppercase;font-size:11px;letter-spacing:.12em}'
   +'.nx-sf-res .big{font-size:46px;font-weight:800;margin:4px 0;letter-spacing:.02em}'
   +'.nx-sf-badge{display:inline-block;margin:6px 0;padding:6px 12px;border-radius:999px;font-weight:600;font-size:13px}'
   +'.nx-sf-badge.ok{background:#e7f6ec;color:#137a3a}'
   +'.nx-sf-badge.na{background:#eee;color:#555}'
   +'.nx-sf-disc{font-size:11px;color:#aaa;margin:16px 0 0}'
   +'.nx-sf-again{background:none;border:0;color:#111;text-decoration:underline;cursor:pointer;font:13px inherit;margin-top:14px}'
   +'.nx-sf-row2{display:flex;gap:10px}.nx-sf-row2 .nx-sf-field{flex:1}'+'#vitals-size_chart,[id*="size_chart"],[id*="size-chart"],[class*="Vtl-SizeChart"],[class*="SizeChart"],[class*="vtls-size-chart"],.vtl-pl-main-widget,[class*="vtl-pl-main-widget"]{display:none !important}';
  var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);

  var PRODUCT=null,KIND=null,GENDER=null,VENDOR='',ALLOW=false,LOADED=false;
  function low(x){return (''+x).toLowerCase();}
  function optVals(p){var v=[];(p.variants||[]).forEach(function(x){(x.options||[]).forEach(function(o){var s=(''+o).trim();if(s&&v.indexOf(s)<0)v.push(s);});});return v;}

  function classify(p){
    var tags=(p.tags||[]).map(low);
    function ht(s){return tags.some(function(t){return t.indexOf(s)>=0;});}
    VENDOR=low(p.vendor||'');
    GENDER = ht('genere: uomo')?'uomo':(ht('genere: donna')?'donna':(ht('genere: bambino')?'bambino':'donna'));
    var shoesTag = ht('reparto: scarpe')||ht('reparto: sneakers')||ht('reparto: sandali')||ht('scarpe')||ht('sneakers')||ht('sandali')||ht('stivali')||ht('mocassini')||ht('decollete')||ht('ballerine')||ht('ciabatte');
    var clothTag = ht('reparto: abbigliamento')||ht('abbigliamento')||ht('maglieria')||ht('felpe')||ht('camicie')||ht('pantaloni')||ht('vestiti')||ht('giacche')||ht('costumi')||ht('t-shirt');
    var vals=optVals(p);
    var hasLetter=vals.some(function(v){return /^(xxs|xs|s|m|l|xl|xxl|3xl|4xl)$/i.test((''+v).replace(/\s/g,''));});
    var hasShoeNum=vals.some(function(v){var n=parseFloat((''+v).replace(',','.'));return !isNaN(n)&&n>=33&&n<=48;});
    if(shoesTag && (hasShoeNum||hasLetter||vals.length>1)){ KIND='shoes'; ALLOW=true; }
    else if(clothTag && (hasLetter||hasShoeNum||vals.length>1)){ KIND='clothing'; ALLOW=true; }
    else if(hasLetter){ KIND='clothing'; ALLOW=true; }
    else { KIND=null; ALLOW=false; }
  }
  function loadProduct(cb){
    if(LOADED){cb(PRODUCT);return;}
    var u=location.pathname.split('?')[0];
    fetch(u+'.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(p){PRODUCT=p;LOADED=true;classify(p);cb(p);}).catch(function(){LOADED=true;cb(null);});
  }

  function shoeEU(cm){ var eu=(cm+1.5)*1.5; return Math.ceil(eu); }
  function shoeAvail(){
    var map={};
    (PRODUCT&&PRODUCT.variants||[]).forEach(function(v){(v.options||[]).forEach(function(o){var n=parseFloat((''+o).replace(',','.'));if(!isNaN(n)&&n>=30&&n<=50){ if(!(n in map)) map[n]=false; if(v.available) map[n]=true; }});});
    return map;
  }
  function fmt(n){ return (n%1)?String(n).replace('.',','):String(n); }
  function bestShoe(eu){
    var map=shoeAvail();
    var avail=Object.keys(map).map(Number).filter(function(n){return map[n];}).sort(function(a,b){return a-b;});
    if(!avail.length) return {size:eu,found:false};
    for(var i=0;i<avail.length;i++){ if(avail[i]>=eu) return {size:avail[i],found:true}; }
    return {size:avail[avail.length-1],found:true};
  }

  var WOMEN=[{l:'XS',it:'38',max:50},{l:'S',it:'40',max:57},{l:'M',it:'42',max:65},{l:'L',it:'44',max:74},{l:'XL',it:'46',max:85},{l:'XXL',it:'48',max:96},{l:'3XL',it:'50',max:999}];
  var MEN=[{l:'XS',it:'44',max:58},{l:'S',it:'46',max:66},{l:'M',it:'48',max:75},{l:'L',it:'50',max:85},{l:'XL',it:'52',max:96},{l:'XXL',it:'54',max:108},{l:'3XL',it:'56',max:999}];
  function clothing(gender,h,w){
    var tab=gender==='uomo'?MEN:WOMEN,idx=tab.length-1;
    for(var i=0;i<tab.length;i++){ if(w<=tab[i].max){idx=i;break;} }
    if(h){ if((gender==='uomo'&&h>=188)||(gender!=='uomo'&&h>=180)) idx=Math.min(tab.length-1,idx+1);
           if((gender==='uomo'&&h<=165)||(gender!=='uomo'&&h<=155)) idx=Math.max(0,idx-1); }
    return {idx:idx,tab:tab};
  }
  function letterAvail(){
    var av={};
    (PRODUCT&&PRODUCT.variants||[]).forEach(function(v){ if(v.available)(v.options||[]).forEach(function(o){ av[low((''+o).trim())]=true; }); });
    return av;
  }
  function bestCloth(tab,idx){
    var av=letterAvail();
    function ok(t){ return av[low(t.l)]||av[low(t.it)]; }
    for(var i=idx;i<tab.length;i++){ if(ok(tab[i])) return {t:tab[i],found:true}; }
    for(var j=idx-1;j>=0;j--){ if(ok(tab[j])) return {t:tab[j],found:true}; }
    return {t:tab[idx],found:false};
  }
  var KIDS=[86,92,98,104,110,116,122,128,134,140,146,152,164];
  function kidsClothing(h){var best=KIDS[0],d=1e9;KIDS.forEach(function(s){var dd=Math.abs(s-h);if(dd<d){d=dd;best=s;}});return best;}

  var ov;
  function ensureOv(){if(ov)return ov;ov=document.createElement('div');ov.className='nx-sf-ov';ov.innerHTML='<div class="nx-sf-card" role="dialog" aria-modal="true"></div>';ov.addEventListener('click',function(e){if(e.target===ov)close();});document.body.appendChild(ov);return ov;}
  function close(){if(ov)ov.classList.remove('on');}
  function card(){return ov.querySelector('.nx-sf-card');}

  function openFinder(){
    ensureOv();ov.classList.add('on');
    card().innerHTML='<div class="nx-sf-head"><h3 class="nx-sf-title">Trova la tua taglia</h3><button class="nx-sf-x" aria-label="Chiudi">&times;</button></div><p class="nx-sf-sub">Un attimo...</p>';
    card().querySelector('.nx-sf-x').addEventListener('click',close);
    loadProduct(function(p){if(!p){card().querySelector('.nx-sf-sub').textContent='Non riesco a leggere questo prodotto. Riprova.';return;}renderQ();});
  }
  function seg(name,opts,sel){var h='<div class="nx-sf-seg" data-seg="'+name+'">';opts.forEach(function(o){h+='<button type="button" data-v="'+o.v+'" class="'+(o.v===sel?'sel':'')+'">'+o.t+'</button>';});return h+'</div>';}

  function renderQ(){
    var c=card();
    var head='<div class="nx-sf-head"><h3 class="nx-sf-title">Trova la tua taglia</h3><button class="nx-sf-x" aria-label="Chiudi">&times;</button></div>';
    var body='';
    if(KIND==='shoes'){
      body+='<p class="nx-sf-sub">Misura la lunghezza del piede e ti diciamo il numero giusto.</p>'
        +'<div class="nx-sf-field"><label>Lunghezza del piede (cm)</label><input id="nxsf-cm" type="number" inputmode="decimal" step="0.1" min="10" max="40" placeholder="es. 26,5"></div>'
        +'<span class="nx-sf-howtoggle">Come si misura?</span>'
        +'<div class="nx-sf-howto">Appoggia il piede scalzo su un foglio contro il muro. Segna il tallone e il dito piu lungo, poi misura la distanza in cm. Se i piedi sono diversi, usa la misura piu lunga.</div>'
        +'<button class="nx-sf-go" id="nxsf-go">Calcola il mio numero</button>';
    } else {
      var g=GENDER==='uomo'?'uomo':(GENDER==='bambino'?'bambino':'donna');
      if(g==='bambino'){
        body+='<p class="nx-sf-sub">Inserisci l&#39;altezza del bambino per la taglia consigliata.</p>'
          +'<div class="nx-sf-field"><label>Altezza (cm)</label><input id="nxsf-h" type="number" inputmode="numeric" min="70" max="175" placeholder="es. 128"></div>'
          +'<button class="nx-sf-go" id="nxsf-go">Calcola la taglia</button>';
      } else {
        body+='<p class="nx-sf-sub">Rispondi a poche domande per la taglia consigliata.</p>'
          +'<div class="nx-sf-field"><label>Genere del capo</label>'+seg('gender',[{v:'donna',t:'Donna'},{v:'uomo',t:'Uomo'}],g)+'</div>'
          +'<div class="nx-sf-row2"><div class="nx-sf-field"><label>Altezza (cm)</label><input id="nxsf-h" type="number" inputmode="numeric" min="130" max="215" placeholder="es. 170"></div>'
          +'<div class="nx-sf-field"><label>Peso (kg)</label><input id="nxsf-w" type="number" inputmode="numeric" min="30" max="180" placeholder="es. 65"></div></div>'
          +'<div class="nx-sf-field"><label>Vestibilita preferita</label>'+seg('fit',[{v:'aderente',t:'Aderente'},{v:'regolare',t:'Regolare'},{v:'comoda',t:'Comoda'}],'regolare')+'</div>'
          +'<button class="nx-sf-go" id="nxsf-go">Calcola la taglia</button>';
      }
    }
    c.innerHTML=head+body;
    c.querySelector('.nx-sf-x').addEventListener('click',close);
    var ht=c.querySelector('.nx-sf-howtoggle');if(ht)ht.addEventListener('click',function(){c.querySelector('.nx-sf-howto').classList.toggle('on');});
    [].forEach.call(c.querySelectorAll('.nx-sf-seg'),function(sg){sg.addEventListener('click',function(e){var b=e.target.closest('button');if(!b)return;[].forEach.call(sg.children,function(x){x.classList.remove('sel');});b.classList.add('sel');});});
    c.querySelector('#nxsf-go').addEventListener('click',calc);
  }
  function segVal(name){var sg=card().querySelector('[data-seg="'+name+'"] .sel');return sg?sg.getAttribute('data-v'):null;}

  function calc(){
    var c=card();
    if(KIND==='shoes'){
      var cm=parseFloat((c.querySelector('#nxsf-cm').value||'').replace(',','.'));
      if(!cm||cm<10||cm>40){alert('Inserisci una misura del piede valida in cm (es. 26,5).');return;}
      var eu=shoeEU(cm);var bs=bestShoe(eu);
      renderRes({label:fmt(bs.size)+' EU',unit:'Numero consigliato',av:{state:bs.found?'ok':'na'}});
      return;
    }
    var g=GENDER==='bambino'?'bambino':(segVal('gender')||GENDER||'donna');
    if(g==='bambino'){
      var h=parseFloat(c.querySelector('#nxsf-h').value);
      if(!h||h<60||h>185){alert('Inserisci un altezza valida in cm.');return;}
      var sz=kidsClothing(h);var av=letterAvail();
      renderRes({label:String(sz),unit:'Taglia consigliata (altezza in cm)',av:{state:av[low(String(sz))]?'ok':'na'}});
      return;
    }
    var hh=parseFloat(c.querySelector('#nxsf-h').value),ww=parseFloat(c.querySelector('#nxsf-w').value);
    if(!ww||ww<25||ww>200){alert('Inserisci un peso valido in kg.');return;}
    var fit=segVal('fit')||'regolare';
    var r=clothing(g,hh,ww);var idx=r.idx,tab=r.tab;
    if(fit==='comoda') idx=Math.min(tab.length-1,idx+1);
    var bc=bestCloth(tab,idx);var cur=bc.t;
    renderRes({label:cur.l+'  ('+cur.it+' IT)',unit:'Taglia consigliata',av:{state:bc.found?'ok':'na'}});
  }

  function renderRes(o){
    var c=card();var badge='';
    if(o.av.state==='ok') badge='<div class="nx-sf-badge ok">Disponibile su questo prodotto</div>';
    else badge='<div class="nx-sf-badge na">Nessuna taglia disponibile su questo prodotto</div>';
    var head='<div class="nx-sf-head"><h3 class="nx-sf-title">La tua taglia</h3><button class="nx-sf-x" aria-label="Chiudi">&times;</button></div>';
    c.innerHTML=head+'<div class="nx-sf-res"><div class="lab">'+o.unit+'</div><div class="big">'+o.label+'</div>'+badge
      +'<div class="nx-sf-disc">Stima indicativa basata su tabelle standard: la vestibilita puo variare per modello.</div>'
      +'<button class="nx-sf-again">Ricomincia</button></div>';
    c.querySelector('.nx-sf-x').addEventListener('click',close);
    c.querySelector('.nx-sf-again').addEventListener('click',renderQ);
  }

  function isPDP(){return /\/products\//.test(location.pathname);}
  function injectBtn(){
    if(!isPDP()) return;
    if(!LOADED){ loadProduct(function(){injectBtn();}); return; }
    if(!ALLOW) return;
    var atcs=[].slice.call(document.querySelectorAll('.add-to-cart-button, button[name="add"]'));
    var target=null;
    function nxbad(a){return a.closest('[class*="sticky-add-to-cart"],[class*="Sticky-add"]')||a.offsetParent===null;}
    for(var i=0;i<atcs.length;i++){if(nxbad(atcs[i]))continue;if(atcs[i].closest('form[action*="/cart/add"]')){target=atcs[i];break;}}
    if(!target){for(var k=0;k<atcs.length;k++){if(!nxbad(atcs[k])){target=atcs[k];break;}}}
    if(!target) return;
    var form=target.closest('form')||target.parentElement;
    if(form.querySelector('.nx-sf-btn')) return;
    var b=document.createElement('button');b.type='button';b.className='nx-sf-btn';
    b.innerHTML='<span style="font-size:16px">&#128207;</span> Trova la tua taglia';
    b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();openFinder();});
    if(target.parentNode) target.parentNode.insertBefore(b,target); else form.appendChild(b);
  }
  var t=null;
  function schedule(){if(t)return;t=setTimeout(function(){t=null;injectBtn();},250);}
  if(isPDP()) loadProduct(function(){injectBtn();});
  if(document.readyState!=='loading') injectBtn(); else document.addEventListener('DOMContentLoaded',injectBtn);
  new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',schedule);
  window.NXSizeFinder={open:openFinder};
})();